import {
  MdBookmark,
  MdDashboard,
  MdGroup,
  MdMap,
  MdPerson,
  MdSearch,
  MdSettings,
} from "react-icons/md";
import { useLocation } from "react-router-dom";
import { useUnreadNotificationCount } from "../../features/social/api/queries";
import { paths } from "../utils/routing";

export interface NavLinkItem {
  key: string;
  path: string;
  icon: React.ReactNode;
  labelKey: string;
  exact?: boolean;
  badge?: number;
}

export const useNavigationLinks = () => {
  const location = useLocation();
  const { data: unreadData } = useUnreadNotificationCount();
  const unreadCount = unreadData?.count ?? 0;

  const navLinks: NavLinkItem[] = [
    {
      key: "discover",
      path: paths.home,
      icon: <MdSearch />,
      labelKey: "navigation.discover",
      exact: true,
    },
    {
      key: "map",
      path: paths.map,
      icon: <MdMap />,
      labelKey: "navigation.map",
    },
    {
      key: "community",
      path: paths.social.community,
      icon: <MdGroup />,
      labelKey: "navigation.community",
      badge: unreadCount > 0 ? unreadCount : undefined,
    },
    {
      key: "profile",
      path: paths.profile,
      icon: <MdPerson />,
      labelKey: "navigation.profile",
    },
    {
      key: "settings",
      path: paths.settings,
      icon: <MdSettings />,
      labelKey: "navigation.settings",
    },
    {
      key: "admin",
      path: paths.admin.home,
      icon: <MdDashboard />,
      labelKey: "navigation.myContent",
    },
  ];

  const isNavLinkActive = (navLink: NavLinkItem) => {
    if (navLink.exact) {
      return location.pathname === navLink.path;
    }
    return location.pathname.startsWith(navLink.path);
  };

  return { navLinks, isNavLinkActive };
};
